module.exports = __webpack_public_path__ + "static/media/armenian.0b90252d.svg";